import {
  SET_CATEGORY_TYPES,
  SET_CATEGORY_TYPES_ERROR,
  SET_CATEGORY_TYPES_LOADING,
  SET_MATERIAL_CATEGORY_TYPES,
  SET_PRODUCT_CATEGORY_TYPES,
} from "../../actions/categoryTypeAction";

const initialState = {
  datas: null,
  productDatas: null,
  materialDatas: null,
  loading: false,
  error: null,
};

const categoryTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORY_TYPES:
      return { ...state, datas: action.data, error: null };
    case SET_PRODUCT_CATEGORY_TYPES:
      return { ...state, productDatas: action.data, error: null };
    case SET_MATERIAL_CATEGORY_TYPES:
      return { ...state, materialDatas: action.data, error: null };
    case SET_CATEGORY_TYPES_LOADING:
      return { ...state, loading: action.status };
    case SET_CATEGORY_TYPES_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default categoryTypeReducer;
